import { parseAxiosError } from './parseApiError';
import { translateApiErrorCode } from './translate';
import type { ApiError } from './types';

export type FieldErrorMap = Record<string, string>;

// Reduce an ApiError.errors dictionary to a flat { fieldName: translatedMessage }
// map, taking the first error per field. Field names match the request DTO in
// camelCase (the API normalizes this regardless of server-side declaration).
//
// Returns an empty object when there are no field errors, so callers can
// unconditionally spread the result into form state.
export function mapApiFieldErrors(error: unknown): FieldErrorMap {
  const apiError: ApiError = parseAxiosError(error);
  if (!apiError.errors) return {};

  const result: FieldErrorMap = {};
  for (const [field, errs] of Object.entries(apiError.errors)) {
    if (!errs || errs.length === 0) continue;
    const first = errs[0];
    result[field] = translateApiErrorCode(first);
  }
  return result;
}

// Convenience: returns true when the error contains per-field validation errors
// (i.e. should be handled inline rather than via toast).
export function hasFieldErrors(error: unknown): boolean {
  const apiError = parseAxiosError(error);
  return !!apiError.errors && Object.keys(apiError.errors).length > 0;
}
